import { InfoCircleTwoTone } from "@ant-design/icons";
import { Finding } from "@p0security/shared/types/assessment/finding";
import { Spin, Typography } from "antd";
import Link from "antd/lib/typography/Link";
import { GraphTooltip } from "components/GraphTooltip";
import { GithubIcon } from "components/Integrations/Github/Github";
import { JiraIcon } from "components/Integrations/Jira/Jira";
import { FirestoreDoc } from "providers/FirestoreProvider";

export const FindingAssignment: React.FC<{
  finding: FirestoreDoc<Finding>;
}> = ({ finding }) => {
  const { assignment, issue, remediation } = finding.data;
  const epicKey = finding.data.issue?.epicKey;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "baseline",
        gap: "1em",
      }}
    >
      {assignment &&
        (assignment.status === "complete" && assignment.assignee ? (
          <Typography.Paragraph>
            Assigned to {assignment.assignee}{" "}
            <GraphTooltip
              title={
                <div>
                  This findings was assigned to {assignment.assignee} for the
                  following reason:
                  <br />
                  {assignment.reason}
                </div>
              }
            >
              <InfoCircleTwoTone />
            </GraphTooltip>
          </Typography.Paragraph>
        ) : assignment.status === "assigning" ? (
          <Typography.Paragraph>
            <Spin /> Determining owner
          </Typography.Paragraph>
        ) : assignment.status === "remediating" ? (
          <Typography.Paragraph>
            <Spin /> Remediating finding
          </Typography.Paragraph>
        ) : assignment.status === "tracking" ? (
          <Typography.Paragraph>
            <Spin /> Creating issue
          </Typography.Paragraph>
        ) : null)}
      <div
        style={{
          gap: "1em",
          display: "flex",
        }}
      >
        {issue && (
          <Typography.Text type="secondary">
            <Link href={issue.link} target="_blank" rel="noopener noreferrer">
              {JiraIcon}&nbsp;View issue
            </Link>
            {epicKey && (
              <>
                &nbsp;| Linked to Epic:{" "}
                <Typography.Text code>{epicKey}</Typography.Text>
              </>
            )}
          </Typography.Text>
        )}
        {remediation && (
          <Link target="_blank" href={remediation.link}>
            {GithubIcon}&nbsp;View PR
          </Link>
        )}
      </div>
    </div>
  );
};
